module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel03_1280_1280_th-e58a51303b10d9c24cd7f16ebde42056.jpg";